import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { BiEventData } from '@fiverr-private/store_builder_bi_events';
import { NicheGrid } from '../niche-grid/NicheGrid';
import { NicheCardProps } from '../niche-card/NicheCard.types';

interface StoreBuilderToggleProps {
    items: NicheCardProps[];
    biEventData: BiEventData;
    pageName: string;
}

export const StoreBuilderToggleNiches: React.FC<StoreBuilderToggleProps> = ({ items, biEventData, pageName }) => (
    <Stack direction="column" width="100%" gap="8" paddingTop="10" marginBottom="20">
        <Typography size="b_xxl" fontWeight="bold" color="grey_1200">
            <I18n k="store_builder_ui.toggle.niches_selection.title" />
        </Typography>
        <NicheGrid
            items={items}
            biEventData={biEventData}
            pageName={pageName}
            HeaderComponent={
                <Typography size="b_xl" fontWeight="bold" color="grey_1200" paddingBottom="4">
                    <I18n k="store_builder_ui.toggle.niches_selection.selection" />
                </Typography>
            }
        />
    </Stack>
);

StoreBuilderToggleNiches.displayName = 'StoreBuilderToggleNiches';
